import { Button, CircularProgress, Typography } from "@mui/material"
import AuthLayout from "../../components/auth-layout"
import { CenteredBox, Conditional, Stack } from "src/shared/components"
import OutlinedInput from "src/shared/components/outlined-input"
import SendIcon from "@mui/icons-material/Send"
import Link from "src/shared/components/Link"
import * as yup from "yup"
import { Controller, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { useForgotPasswordMutation } from "src/graphql/quark/quark.type"
import { toast } from "react-toastify"
import { useState } from "react"

const validationSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required")
})
const ForgotPassword = () => {
  const [isEmailSent, setEmailSent] = useState(false)
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: { email: "" }
  })

  const [forgotPassword, { loading }] = useForgotPasswordMutation()
  const onSubmit = async ({ email }: { email: string }) => {
    const resp = await forgotPassword({ variables: { email, origin: window.location.origin } })
    if (resp?.data?.forgotPassword) {
      toast.success("Email sent successfully")
      setEmailSent(true)
    }
  }
  return (
    <AuthLayout>
      <CenteredBox sx={{ height: "100%" }}>
        <Stack sx={{ width: "100%" }} spacing={2}>
          <Typography variant="h3" textAlign={"center"}>
            Forgot Password
          </Typography>
          <Typography variant="body1" textAlign="center" color="text.secondary" gutterBottom>
            You will receive a link to create a new password via email
          </Typography>
          <Controller
            name="email"
            control={control}
            render={({ field, fieldState }) => (
              <OutlinedInput
                {...field}
                type="email"
                required
                label="Email"
                placeholder="enter your email"
                error={!!fieldState?.error}
                helperText={fieldState.error?.message}
              />
            )}
          />
          <Conditional condition={isEmailSent}>
            <Typography variant="subtitle1">we have sent you an email, please Check your email</Typography>
          </Conditional>
          <Link to="/" style={{ textAlign: "right", fontSize: "0.75rem", width: "100%" }}>
            Login
          </Link>
        </Stack>

        <Stack mt={2} sx={{ width: "100%" }}>
          <Button
            variant="contained"
            endIcon={<SendIcon fontSize="small" />}
            fullWidth
            onClick={handleSubmit(onSubmit)}
            disabled={loading || isEmailSent}
          >
            {loading ? <CircularProgress size="1rem" /> : "Send Email"}
          </Button>
        </Stack>
      </CenteredBox>
    </AuthLayout>
  )
}

export default ForgotPassword
